import React from 'react';

import { UISlider } from 'components/ui';

export const TemplateStudioSlider: React.FC<{
  value: number;
  onChange: (value: number) => void;
  label?: string;
  min?: number;
  max?: number;
  step?: number;
}> = ({ value, onChange, label, min = 1, max = 10, step = 1 }) => {
  const handleValueChange = (values: number[]) => {
    if (values.length > 0) {
      onChange(values[0]);
    }
  };

  return (
    <div className="template-slider flex flex-col gap-2">
      <div className="flex items-center gap-2 my-2">
        {label && <span className="text-xs text-black">{label}</span>}
        <span className="text-xs text-black ml-auto">
          {value}
          {value === max && '+'}
        </span>
      </div>
      <UISlider
        value={[value]}
        onValueChange={handleValueChange}
        min={min}
        max={max}
        step={step}
        className="w-full my-2 cursor-pointer"
      />
    </div>
  );
};
